var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiringSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F6F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.667 14.084H12.3337C11.6893 14.084 11.167 14.6063 11.167 15.2507V21.084C11.167 21.7283 11.6893 22.2507 12.3337 22.2507H21.667C22.3113 22.2507 22.8337 21.7283 22.8337 21.084V15.2507C22.8337 14.6063 22.3113 14.084 21.667 14.084Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 22.25V12.9167C19.3337 12.6072 19.2107 12.3105 18.9919 12.0917C18.7732 11.8729 18.4764 11.75 18.167 11.75H15.8337C15.5242 11.75 15.2275 11.8729 15.0087 12.0917C14.7899 12.3105 14.667 12.6072 14.667 12.9167V22.25",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringSelect);
export default __webpack_public_path__ + "static/media/hiring-select.400cf594dd178359986abb0b82e27628.svg";
export { ForwardRef as ReactComponent };